import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const KmapBooleanLogicAdderMuxDemux = () => (
  <QPhototModuleSubtopic
    title="K-map, Boolean , Logic gate, Adder, Multiplexer, Demultiplexer"
    videos={[
      "https://www.youtube.com/embed/EW_2MhFu7tE",
      "https://www.youtube.com/embed/FPrcIhqNPVo",
      "https://www.youtube.com/embed/RO5alU6PpSU",
      "https://www.youtube.com/embed/lw1STgKUpW0",
      "https://www.youtube.com/embed/K2cpJex0o_A",
      "https://www.youtube.com/embed/xnLBbOYYnHM",
      "https://www.youtube.com/embed/FKvnmxte98A",
      "https://www.youtube.com/embed/g1Lfz1XgrH8",
      "https://www.youtube.com/embed/b0z7YKKCCyY",
      "https://www.youtube.com/embed/5XbRIVWFRIw",
      "https://www.youtube.com/embed/RK3P9L2ZXk4"
    ]}
    takeaways={[
      { text: "Learn SOP and POS questions. Mostly SOP is asked." },
      { text: "Practice K-maps." },
      { text: "Logic gates, Design of combinational circuits." },
      { text: "Questions from adder and multiplexers are also asked." }
    ]}
    questions={[
      { image: "/beee_42.jpeg" },
      { image: "/beee_43.jpeg" },
      { image: "/beee_44.jpeg" },
      { image: "/beee_45.jpeg" },
      { image: "/beee_46.jpeg" },
      { image: "/beee_47.jpeg" },
      { image: "/beee_48.jpeg" },
      { image: "/beee_49.jpeg" },
      { image: "/beee_50.jpeg" }
    ]}
    exampleVideos={[]}
  />
);

export default KmapBooleanLogicAdderMuxDemux;
